/**
 * Handles loading the new pages and the browser's back button test
 */
export default class Pages {

    constructor() {
        if (Modernizr.history) {
            this.setEventListeners();
        }
    }


    /**
     * Create event listeners - will begin transition
     */
    setEventListeners() {
        let t = this;
        $(document).on('click', '.transition-link', function(e) {
            e.preventDefault();
            t.begin(t, $(this), e);
        });
        setTimeout(() => {
            $(window).on('popstate', this.handleBackButton);
        }, 500);
    }


    /**
     * Begin loading another page
     * @param t - this, Pages object
     * @param el - DOM element that was clicked
     * @param event - event from click
     */
    begin(t, el, event) {
        event.preventDefault();
        event.stopPropagation();

        // New page data
        let newData = {
            href: el.attr('href'),
            title: el.attr('title')
        };

        window.newData = newData;

        // Show loading bars
        window.PageLoader.show(newData.title);

        // Load new page data
        t.getData(newData.href, newData.title);
    }


    /**
     * Perform ajax call to get page data
     * @param url - URL of new page
     * @param title - Title of new page
     */
    getData(url, title) {
        let t = this;
        let newPage = $('<div class="new-page"></div>');
        let returnData = {
            page: null,
            url: url,
            title: title,
            success: false,
        };

        newPage.load(url + " #page-content > *", function(response, status, xhr) {
            returnData.page = newPage;
            returnData.success = (status !== 'error');
            if (returnData.success) {
                return (xhr.status === 200) ? t.changePage(returnData, true) : t.forceRedirect(url); 
            }
            return window.PageLoader.close();
        });
    }


    /**
     * Get new page data and update content
     * @param pageData - new page data
     * @param pushHistory - boolean if we should push to the history state or not
     */
    changePage(pageData, pushHistory) {

        window.MainNav.close();

        if (pageData.success) {
            // Update page data
            this.updatePageData(pageData);
            // Push history if needed
            pushHistory ? this.updateHistory(pageData) : null;
            // Send google analytics
            this.sendAnalytics(pageData.url);
            return true;
        }
        else {
            // Loading failed, force redirect to that page
            return this.forceRedirect(pageData.url);
        }

    }


    /**
     * Update page data once all images for new page
     * are loaded and the loading bar animation
     * is complete
     * @param t = Pages reference
     * @param content - new page html
     * @param url - URL of new page
     * @param pageTitle - Title of new page
     */
    updatePageData(data) {
        let done = false;

        setTimeout(()=>{
            // Update #page-content with new html
            $("#page-content").html(data.page);

            window.App.checkURL();

            // Wait for all iamges to be loaded before revealing the page
            $("#page-content").find('*').imagesLoaded({background:true}, function() {
                window.PageLoader.close();
                done = true;
            });

            // Set the active subnav link now that the page has changed
            window.Subnavs.setActiveLink();

            // Reveal content after 8 seconds if taking forever to load
            setTimeout(() => {
                if (!done) {
                    window.PageLoader.close();
                }
            }, 5000);
        }, window.PageLoader.animationDuration);
    }


    /**
     * Update history state
     * @param data - Page data
     */
    updateHistory(data) {
        if (Modernizr.history && data.url !== window.location) {
            window.history.pushState({loaded: true}, data.title, data.url);
            document.title = data.title + " | Blake Griffin";
        }
    }


    /**
     * Force a redirect to a url
     * @param url - URL to redirect to
     */
    forceRedirect(url) {
        window.location = url;
    }


    /**
     * Sends a new page view every time the page transitions for SEO purposes.
     * @param url
     */
    sendAnalytics(url) {
        ga('set', 'page', url);
        ga('send', 'pageview', url);
    }


    /**
     * Handle back button clicks
     */
    handleBackButton(e) {
        e.stopPropagation();
        e.preventDefault();

        if (!window.PageLoader.isAnimating) {
            // page url to be loaded
            let newPageArray = window.location.pathname.split('/');
            let newPage = newPageArray[newPageArray.length - 1];

            // page title
            let newPageTitle = newPage.replace(/-/g,' ');
            if (newPageTitle.length <= 0) {
                newPageTitle = "Home";
            }
            newPageTitle = newPageTitle.charAt(0).toUpperCase() + newPageTitle.slice(1);

            // Change page
            let pageData = {
                url: newPage,
                title: newPageTitle
            };

            // Show loading bars
            window.PageLoader.show(pageData.title);

            // Update page
            window.Pages.changePage(pageData, false);
        }
        // Redirect to desired page if page transition was interrupted
        else {
            window.location = window.location;
        }
    }
}


// WEBPACK FOOTER //
// ./public/js/Pages.js